import { render, staticRenderFns } from "./beer-can.vue?vue&type=template&id=4e7ab471"
import script from "./beer-can.vue?vue&type=script&lang=js"
export * from "./beer-can.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports